import { createContext, useContext } from 'react'

import type { OpportunityType } from '@/types/Opportunity'
import type { SearchOut } from '@/types/Search'

/**
 * Context value for SimilarOpportunitiesV2 compound component
 */
export interface SimilarOpportunitiesContextValue {
  /** Opportunity type - used for route building */
  type: OpportunityType
  /** Array of similar opportunities */
  opportunities: SearchOut[]
  /** Loading state */
  isLoading: boolean
  /** Unique ID for aria-labelledby */
  headingId: string
}

/**
 * Context for SimilarOpportunitiesV2 compound component
 * Provides type, data, and loading state to sub-components
 */
export const SimilarOpportunitiesContext =
  createContext<SimilarOpportunitiesContextValue | null>(null)

/**
 * Hook to access SimilarOpportunitiesV2 context
 * Must be used within a SimilarOpportunitiesV2 root component
 */
export function useSimilarOpportunitiesContext(): SimilarOpportunitiesContextValue {
  const context = useContext(SimilarOpportunitiesContext)
  if (!context) {
    throw new Error(
      'useSimilarOpportunitiesContext must be used within SimilarOpportunitiesV2',
    )
  }
  return context
}
